import Vue from "vue";
import VueRouter from "vue-router";

import tvchart from "../views/tvChart.vue";
//rules

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "tvchart",
    component: tvchart,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
